export default __webpack_public_path__ + "locales/es/Files.json?hash=a7ef328e6c67f41cd88bf7f3adb6540c";